module.exports = __webpack_public_path__ + "static/twitter-a463c08a694c6db4044631a23223e36a.jpg";